import React from 'react';
import * as Routes from '@/modules/routes';
import I18n from 'i18n-js';
import { tv } from 'tailwind-variants';
import useFlags from '@/hooks/useFlags';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import Text from '@/components/ui/Text';
import readingIcon from 'images/icons/reading.svg';
import calendarIcon from 'images/icons/calendar-plus.svg';
import { CARD_HEIGHT_REFLOW } from '@/components/shared/NewLessonOverview/reflowStyles';
import { IReading } from '../types';
import { readingLabel } from '../DiveDeeper.utils';

type CardProps = {
  reading? : IReading;
  openAssign: () => void;
  setInitialValues: (any) => void;
};

const cardStyles = tv({
  base: [
    'tw-border tw-border-solid tw-border-med-grey tw-shadow-lg tw-max-w-3xl',
    'tw-rounded-lg tw-flex tw-justify-start tw-items-center tw-bg-white',
  ],
  variants: {
    reflow: {
      false: 'tw-h-[4.5rem]',
      true: CARD_HEIGHT_REFLOW,
    },
  },
});

const ReadingCard = ({ openAssign, reading, setInitialValues } : CardProps) => {
  const { accessibilityReflow } = useFlags();
  const programId = useLessonOverviewContext(state => state.programId);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);
  const readingPath = Routes.shared_section_path(reading.id, { program_id: programId });
  const sections = useLessonOverviewContext(state => state.sections);

  const onAssignmentButtonClick = () => {
    setInitialValues({
      modelType: 'sectionNotebook',
      modelsToAssign: sections.map(section => section.assignable.value),
    });
    openAssign();
  };

  return (
    <>
      <div className={cardStyles({ reflow: accessibilityReflow })}>
        <div className="tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-bg-blue tw-min-h-[2.5rem]
          tw-min-w-[2.5rem] tw-mx-[1rem]"
        >
          <img alt="" className="tw-invert" src={readingIcon} />
        </div>
        <Text asChild className="tw-font-bold" size="sm" variant="body">
          <a
            className="tw-mb-0 tw-max-h-[80%] tw-text-tci-purple tw-w-[67%] tw-mr-auto
            tw-text-ellipsis tw-overflow-hidden"
            href={readingPath}
          >
            {`${readingLabel(reading.kind)} : ${reading.subtitle}`}
          </a>
        </Text>
        {!reading.isAssigned && isStaffer && (
          <button
            aria-label={I18n.t('create_assignment')}
            className="tw-bg-transparent tw-border-none focus:tw-border-none active:tw-border-none tw-cursor-pointer
            focus:tw-outline-none"
            type="button"
            onClick={onAssignmentButtonClick}
          >
            <img
              alt=""
              className="tw-mr-[1rem]"
              src={calendarIcon}
            />
          </button>
        )}
      </div>
    </>
  );
};
export default ReadingCard;
